import { FC } from 'react';
import { SplitShares } from 'types/splits.types';
import { useAppDispatch, useAppSelector } from 'app/store';
import {
  createSplitEffect,
  fetchPossibleSplitMembersEffect,
} from 'app/store/SongList/effects';
import {
  getLatestSplit,
  getPossibleSplitMembersList,
} from 'app/store/SongList/selectors';
import { useResource } from 'app/utils/hooks';
import { NewSplitOverlayComponent } from './NewSplitOverlayComponent';

interface NewSplitOverlayProps {
  onClose: () => void;
}

export const NewSplitOverlay: FC<NewSplitOverlayProps> = ({ onClose }) => {
  const dispatch = useAppDispatch();
  const [
    possibleMembers,
    possibleMembersLoading,
  ] = useResource(
    fetchPossibleSplitMembersEffect,
    getPossibleSplitMembersList,
    { useCache: false }
  );
  const currentMembers = useAppSelector(getLatestSplit)?.members.map(
    (member) => ({
      ...member,
      profile: member.profileCard,
    })
  );

  const onSubmit = async (values: SplitShares) => {
    try {
      await dispatch(createSplitEffect({ splitShares: values })).unwrap();
      onClose();
    } catch (e) {
      // continue
    }
  };

  return (
    <NewSplitOverlayComponent
      onClose={onClose}
      isLoading={possibleMembersLoading}
      possibleMembers={possibleMembers}
      currentMembers={currentMembers}
      onSubmit={onSubmit}
    />
  );
};
